export const servicesData = [
  {
    n: '01',
    cat: '긴급 대응',
    catClass: 'cat-b',
    title: '지금 당장 어떻게 해야 할지\n모르겠을 때',
    img: 'https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?w=600&auto=format&fit=crop&q=80',
    imgAlt: '의료 긴급 상담',
    desc: '환자 클레임 전화를 받은 그 순간, 보건소 조사관이 들어온 그 순간—바로 연결됩니다. 첫 1시간의 대응이 결과를 바꿉니다.',
    details: [
      { label: '환자 클레임·합의 요구 즉시 대응', dotClass: '' },
      { label: '보건소 현장조사 현장 가이드', dotClass: '' },
      { label: '직원 분쟁·인사 문제 긴급 상담', dotClass: '' },
    ],
    note: null,
    highlight: null,
    defaultOpen: true,
    slug: 'emergency',
    ctaLabel: '지금 바로 통화 연결',
    detailIntro:
      '환자 클레임 전화를 받은 그 순간, 보건소 조사관이 들어온 그 순간—첫 1시간의 대응이 결과를 바꿉니다. 의료인 출신 변호사가 직접 실시간 대응 가이드를 제공합니다.',
    detailSections: [
      {
        heading: '이런 상황에 즉시 도움이 됩니다',
        bullets: [
          '환자가 직접 전화로 합의금을 요구하는 상황',
          '보건소·복지부 현장 조사가 예고 없이 도착',
          '직원이 부당해고를 주장하며 노동부에 신고하겠다고 말하는 상황',
        ],
      },
      {
        heading: '오킴스 의료팀이 제공하는 것',
        bullets: [
          '전화 한 통으로 즉시 연결되는 실시간 상담',
          '그 자리에서 쓸 수 있는 대응 스크립트 제공',
          '추가 법적 조치가 필요한지 즉시 판단',
        ],
      },
    ],
  },
  {
    n: '02',
    cat: '의료사고',
    catClass: 'cat-b',
    title: '내 과실인지 아닌지,\n정확히 알고 싶을 때',
    img: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=600&auto=format&fit=crop&q=80',
    imgAlt: '의료사고 전문 상담',
    desc: '일반 변호사는 의무기록을 읽지 못합니다. 의사 출신 변호사가 임상 기준으로 직접 과실 여부를 판단하고, 소송 전 리스크를 정확히 잡아드립니다.',
    details: [
      { label: '의료과실 여부 임상 직접 감정', dotClass: '' },
      { label: '적정 합의금 범위 산정', dotClass: '' },
      { label: '초동 대응 전략 수립', dotClass: '' },
    ],
    note: null,
    highlight: null,
    defaultOpen: false,
    slug: 'malpractice',
    ctaLabel: '의료과실 자문 요청',
    detailIntro:
      '일반 변호사는 의무기록을 읽지 못합니다. 의사 출신 변호사가 임상 기준으로 직접 과실 여부를 판단하고, 소송 전 리스크를 정확히 잡아드립니다.',
    detailSections: [
      {
        heading: '우리가 검토하는 것',
        bullets: [
          '의무기록·수술기록·영상자료 임상 직접 판독',
          '학회 가이드라인·진료지침과의 부합 여부',
          '인과관계·후유장해·위자료 산정 기준',
        ],
      },
      {
        heading: '대응 전략',
        bullets: ['합의 vs 소송 판단', '적정 합의금 범위 산정', '의료감정·심사평가원 대응'],
      },
    ],
  },
  {
    n: '03',
    cat: '협상 대행',
    catClass: 'cat-t',
    title: '환자와 직접\n마주치지 않아도 됩니다',
    img: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&auto=format&fit=crop&q=80',
    imgAlt: '협상 대행',
    desc: '원장님은 진료에 집중하세요. 협상 전화·공문·행정기관 소통까지 오킴스 의료팀이 처음부터 끝까지 직접 대행합니다.',
    details: [
      { label: '환자 측 협상 전 과정 대행', dotClass: '' },
      { label: '보건소·복지부 공식 소통 대행', dotClass: '' },
      { label: '법무법인 명의 협상 서한 발송', dotClass: '' },
    ],
    note: null,
    highlight: null,
    defaultOpen: false,
    slug: 'negotiation',
    ctaLabel: '협상 대행 의뢰하기',
    detailIntro:
      '원장님은 진료에 집중하세요. 협상 전화·공문·행정기관 소통까지 오킴스 의료팀이 처음부터 끝까지 직접 대행합니다.',
    detailSections: [
      {
        heading: '대행 범위',
        bullets: [
          '환자 측 대리인·보험사와의 협상',
          '보건소·복지부 공식 공문 및 소명서 작성',
          '법무법인 명의 협상 서한 발송',
        ],
      },
      {
        heading: '원장님이 하지 않아도 되는 것',
        bullets: ['감정적 전화 통화', '직접 작성하기 부담스러운 공식 문서', '행정기관 직접 출석'],
      },
    ],
  },
  {
    n: '04',
    cat: '법률 문서',
    catClass: 'cat-t',
    title: '말로 안 될 때,\n법무법인 명의로 보냅니다',
    img: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&auto=format&fit=crop&q=80',
    imgAlt: '내용증명 문서 발송',
    desc: '악성 민원, 허위 후기, 근거 없는 손해배상 요구—공식 법률 문서 한 장이 분위기를 바꿉니다. 법무법인 오킴스 명의의 무게감이 다릅니다.',
    details: [
      { label: '내용증명 작성 및 법무법인 명의 발송', dotClass: '' },
      { label: '악성 민원·허위 사실 유포 경고장', dotClass: '' },
    ],
    note: null,
    highlight: null,
    defaultOpen: false,
    slug: 'documents',
    ctaLabel: '법무법인 명의 문서 요청',
    detailIntro:
      '악성 민원, 허위 후기, 근거 없는 손해배상 요구—공식 법률 문서 한 장이 분위기를 바꿉니다. 법무법인 오킴스 명의의 무게감이 다릅니다.',
    detailSections: [
      {
        heading: '문서 종류',
        bullets: [
          '내용증명 (손해배상 요구·합의 종결 등)',
          '경고장 (악성 민원·허위 후기 유포자 대상)',
          '고소장·고발장 (명예훼손·업무방해)',
        ],
      },
      {
        heading: '발송 프로세스',
        bullets: [
          '의뢰인 상황 파악 및 사실관계 정리',
          '초안 작성 후 24시간 내 검토 요청',
          '우체국 배달증명 발송 및 수령 확인',
        ],
      },
    ],
  },
  {
    n: '05',
    cat: '인사노무',
    catClass: 'cat-g',
    title: '병원 직원 문제,\n일반 노무사로는 한계가 있습니다',
    img: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=600&auto=format&fit=crop&q=80',
    imgAlt: '인사노무 전문 서비스',
    desc: '면허직 고용 구조, 당직·야간 수당, 부당해고 주장—의료기관의 특수한 환경을 의료법과 노동법 양쪽으로 이해하는 팀만이 제대로 처리할 수 있습니다.',
    details: [
      { label: '부당해고 주장·직원 분쟁 즉시 대응', dotClass: 'g' },
      { label: '징계·해고 절차 단계별 법률 가이드', dotClass: 'g' },
      { label: '인사·징계위원회 구성 지원', dotClass: 'g' },
    ],
    note: null,
    highlight: null,
    defaultOpen: false,
    slug: 'hr-labor',
    ctaLabel: '인사노무 상담 요청',
    detailIntro:
      '면허직 고용 구조, 당직·야간 수당, 부당해고 주장—의료기관의 특수한 환경을 의료법과 노동법 양쪽으로 이해하는 팀만이 제대로 처리할 수 있습니다.',
    detailSections: [
      {
        heading: '자주 발생하는 분쟁',
        bullets: [
          '의사·간호사·치과위생사 부당해고 주장',
          '근무시간·당직·야간 수당 산정 분쟁',
          '직장 내 괴롭힘·성희롱 신고 대응',
        ],
      },
      {
        heading: '일반 노무사와의 차이',
        bullets: [
          '의료법상 면허직 고용 구조 이해',
          '의료기관 취업규칙 설계 경험',
          '노동위원회·법원 실전 대응',
        ],
      },
    ],
  },
];
